exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-height-tit .weui_cell_primary{line-height:.48rem}.mt20{margin-top:.26666667rem}.bg-dfe4f0-h80{background:#dfe4f0;height:1.06666667rem;-webkit-box-sizing:border-box;box-sizing:border-box}.bg-dfe4f0-h80:before{display:none}", ""]);

// exports
